var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"singin"},[_c('signinComponent',{attrs:{"eermsg":_vm.eermsg},on:{"signin":_vm.signin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }